// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tXau","content":"styles_content__3RkOZ"};